import React, { createContext, useContext, useState } from 'react';
export let View = /*#__PURE__*/function (View) {
  View["Menu"] = "menu";
  View["Speed"] = "speed";
  View["Quality"] = "quality";
  View["Subtitles"] = "subtitles";
  return View;
}({});
const ViewContext = /*#__PURE__*/createContext(null);
export const ViewProvider = _ref => {
  let {
    children
  } = _ref;
  const [view, setView] = useState(View.Menu);
  return /*#__PURE__*/React.createElement(ViewContext.Provider, {
    value: {
      view,
      setView
    }
  }, children);
};
export const useView = () => {
  const context = useContext(ViewContext);
  if (context === null) {
    throw new Error('ViewContext is null');
  }
  return context;
};
//# sourceMappingURL=ViewProvider.js.map